import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "../legal/legal.css";

function ContactUs() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <button type="button" className="legal-back-btn" onClick={() => navigate(-1)}>
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1 className="fw-bold mb-2">{isNe ? "सम्पर्क गर्नुहोस्" : "Contact Us"}</h1>
          <p className="mb-0 opacity-75">
            {isNe ? "भाडावाल र सम्पत्ति मालिकका लागि नेपाल-आधारित सहयोग।" : "Nepal-based support for renters and property owners."}
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">

            <div className="row g-4 mb-5">
              {/* General support */}
              <div className="col-md-6">
                <div className="legal-card h-100">
                  <h2 className="legal-section-title">{isNe ? "सामान्य सहयोग" : "General Support"}</h2>
                  <p className="text-muted mb-3">{isNe ? "सूची, खाता, आवेदन र अन्य प्रश्नहरूका लागि।" : "For questions about listings, accounts, applications, and anything else."}</p>
                  <a href="mailto:support@gharbhada.org" className="fw-bold text-decoration-none" style={{ color: "var(--gb-primary)" }}>
                    support@gharbhada.org
                  </a>
                  <p className="text-muted small mt-2 mb-0">{isNe ? "सोम–शनि · सामान्यतया केही घण्टाभित्र जवाफ" : "Mon–Sat · Typically responds within a few hours"}</p>
                </div>
              </div>

              {/* Legal / Privacy */}
              <div className="col-md-6">
                <div className="legal-card h-100">
                  <h2 className="legal-section-title">{isNe ? "कानुनी र गोपनीयता" : "Legal & Privacy"}</h2>
                  <p className="text-muted mb-3">{isNe ? "गोपनीयता अनुरोध, डेटा मेटाउने, कानुनी सूचना र अनुपालनका लागि।" : "For privacy requests, data deletion, legal notices, and compliance matters."}</p>
                  <a href="mailto:legal@gharbhada.org" className="fw-bold text-decoration-none" style={{ color: "var(--gb-primary)" }}>
                    legal@gharbhada.org
                  </a>
                  <p className="text-muted small mt-2 mb-0">{isNe ? "कानुनी अनुरोधमा ५ कार्यदिवसभित्र प्रतिक्रिया दिन्छौं" : "We respond to legal requests within 5 business days"}</p>
                </div>
              </div>

              {/* Safety / Report */}
              <div className="col-md-6">
                <div className="legal-card h-100">
                  <h2 className="legal-section-title">{isNe ? "सुरक्षा र ठगी रिपोर्ट" : "Safety & Fraud Reports"}</h2>
                  <p className="text-muted mb-3">{isNe ? "ठगी सूची, शंकास्पद प्रयोगकर्ता वा सुरक्षा चिन्ता रिपोर्ट गर्न।" : "To report a scam listing, suspicious user, or safety concern."}</p>
                  <a href="mailto:support@gharbhada.org?subject=Safety%20Report" className="fw-bold text-decoration-none" style={{ color: "var(--gb-accent)" }}>
                    support@gharbhada.org
                  </a>
                  <p className="text-muted small mt-2 mb-0">{isNe ? "Subject लाइन प्रयोग गर्नुहोस्: " : "Use subject line: "}<em>Safety Report</em></p>
                </div>
              </div>

              {/* Press */}
              <div className="col-md-6">
                <div className="legal-card h-100">
                  <h2 className="legal-section-title">{isNe ? "मिडिया र साझेदारी" : "Press & Partnerships"}</h2>
                  <p className="text-muted mb-3">{isNe ? "मिडिया सोधपुछ, साझेदारी प्रस्ताव र व्यवसायिक सहकार्यका लागि।" : "For media inquiries, partnership proposals, and business development."}</p>
                  <a href="mailto:legal@gharbhada.org" className="fw-bold text-decoration-none" style={{ color: "var(--gb-primary)" }}>
                    legal@gharbhada.org
                  </a>
                  <p className="text-muted small mt-2 mb-0">{isNe ? "आफ्नो सोधपुछको छोटो विवरण समावेश गर्नुहोस्" : "Include a brief description of your inquiry"}</p>
                </div>
              </div>
            </div>

            {/* Location */}
            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "हाम्रो स्थान" : "Our Location"}</h2>
              <p className="mb-1"><strong>GharBhada</strong></p>
              <p className="text-muted mb-0">Kathmandu Valley, Nepal</p>
              <p className="text-muted small mt-2">
                {isNe
                  ? "हामी डिजिटल-प्रथम प्लेटफर्म हौं। सबै सहयोग इमेलमार्फत हुन्छ। हाल प्रत्यक्ष कार्यालय उपलब्ध छैन।"
                  : "We are a digital-first platform. All support is handled via email. We do not have a walk-in office at this time."}
              </p>
            </div>

            {/* Useful links */}
            <div className="legal-card">
              <h2 className="legal-section-title">{isNe ? "सम्पर्क गर्नु अघि" : "Before You Contact Us"}</h2>
              <p className="text-muted mb-3">{isNe ? "यी स्रोतहरूमा तुरुन्त उत्तर भेटिन सक्छ:" : "You may find an immediate answer in one of these resources:"}</p>
              <ul className="mb-0">
                <li className="mb-2">
                  <button type="button" className="btn btn-link p-0 text-decoration-none" style={{ color: "var(--gb-primary)" }}
                    onClick={() => navigate("/help")}>{isNe ? "मद्दत केन्द्र — बारम्बार सोधिने प्रश्नहरू" : "Help Center — Frequently Asked Questions"}</button>
                </li>
                <li className="mb-2">
                  <button type="button" className="btn btn-link p-0 text-decoration-none" style={{ color: "var(--gb-primary)" }}
                    onClick={() => navigate("/safety")}>{isNe ? "सुरक्षा केन्द्र — GharBhada मा सुरक्षित कसरी रहने" : "Safety Center — How to stay safe on GharBhada"}</button>
                </li>
                <li className="mb-2">
                  <button type="button" className="btn btn-link p-0 text-decoration-none" style={{ color: "var(--gb-primary)" }}
                    onClick={() => navigate("/community-guidelines")}>{isNe ? "समुदाय निर्देशिका" : "Community Guidelines"}</button>
                </li>
                <li>
                  <button type="button" className="btn btn-link p-0 text-decoration-none" style={{ color: "var(--gb-primary)" }}
                    onClick={() => navigate("/privacy-policy")}>{isNe ? "गोपनीयता नीति" : "Privacy Policy"}</button>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
